// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DeliveryNoDocumentsDealerCriteria from '../../../../src/reports/delivery-no-documents/components/delivery-no-documents-dealer-criteria';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const DeliveryNoDocumentsCriteria = props =>
    <div className='delivery-no-documents-criteria'>
        <div className='criteria'>
            <DeliveryNoDocumentsDealerCriteria
                allowedAccounts={props.allowedAccounts}
                onDealerSelect={props.onDealerSelect}
                onSelectAllDealers={props.onSelectAllDealers}
                selectedDealers={props.selectedDealers}
            />
            <LabeledCriteria
                className='days-criteria'
                isRequired={true}
                label='DAYS_FROM_REGISTRATION'
                onInputChange={props.onDaysFromRegistrationChange}
                placeholder='ENTER_A_NUMBER_BETWEEN_0_AND_1000'
                type='number'
                value={props.daysFromRegistration}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

DeliveryNoDocumentsCriteria.displayName = 'DeliveryNoDocumentsCriteria';
DeliveryNoDocumentsCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    daysFromRegistration: PropTypes.number,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onDaysFromRegistrationChange: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default DeliveryNoDocumentsCriteria;



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/components/delivery-no-documents-report-criteria.js